import { types } from 'mobx-state-tree'

export default types.model('AllTeachersModel', {
    teacherId: types.optional(types.string, ''),
    teachersName: types.optional(types.string, ''),
    teachersFirstName: types.maybeNull(types.string),
    teachersLastName: types.maybeNull(types.string),
    teacherPhoto: types.maybeNull(types.string)
})
